import { icons, Wrench } from "lucide-react";
import { useState } from "react";
import { cn } from "@/utils/cn";

const toPascalCase = (name: string) =>
  name
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");

const isUrl = (value: string) => /^https?:\/\//i.test(value);

export const ActionIcon = ({
  icon,
  size = 14,
  className,
}: {
  icon?: string;
  size?: number;
  className?: string;
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  if (icon && isUrl(icon) && !imageFailed) {
    return (
      <img
        src={icon}
        alt=""
        width={size}
        height={size}
        className={cn("rounded-sm shrink-0 object-contain", className)}
        onError={() => setImageFailed(true)}
      />
    );
  }

  let LucideIcon = Wrench;
  if (icon && !isUrl(icon)) {
    const name = toPascalCase(icon.replace(/^lucide:/i, ""));
    LucideIcon = (icons as Record<string, typeof Wrench>)[name] || Wrench;
  }

  return <LucideIcon size={size} className={cn("shrink-0", className)} />;
};
